<template>
  <v-app style="background-color:white;">
    <v-card class="form-container" flat>
      <div style="text-align:right">
        <v-btn @click="onEdit(companies)" color="#E4573D" depressed dark small>Edit<v-icon small >create</v-icon></v-btn>
      </div>
      <h2 style="text-align:center;">Company Details</h2>

      <v-layout class="form-container" row wrap style="margin-top:-20px">
        <v-flex xs4 sm4 md2>
          ◉ Company Name
        </v-flex>
        <v-flex xs8 sm8 md10>
          :&nbsp;&nbsp;{{companies.companyName}}
        </v-flex>
        <v-flex xs4 sm4 md2>
          ◉ Company Code
        </v-flex>
        <v-flex xs8 sm8 md10>
          :&nbsp;&nbsp;{{companies.companyCode}}
        </v-flex>
      </v-layout>

      <v-layout class="form-container" row wrap style="border:1px solid;margin-top:-50px">
        <v-flex xs12>
          <h4 style="text-align:right;color:grey">Contact Info</h4>
        </v-flex>
        <v-flex xs4 sm4 md2>
          ◉ Contact Person
        </v-flex>
        <v-flex xs8 sm8 md10>
          :&nbsp;&nbsp;{{companies.contactName}}
        </v-flex>
        <v-flex xs4 sm4 md2>
          ◉ Contact Number
        </v-flex>
        <v-flex xs8 sm8 md10>
          :&nbsp;&nbsp;{{companies.contactNumber}}
        </v-flex>
        <v-flex xs4 sm4 md2>
          ◉ Email Address
        </v-flex>
        <v-flex xs8 sm8 md10>
          :&nbsp;&nbsp;{{companies.email}}
        </v-flex>
        <v-flex xs4 sm4 md2>
          ◉ GST Number
        </v-flex>
        <v-flex xs8 sm8 md10>
          :&nbsp;&nbsp;{{companies.gstNumber}}
        </v-flex>
        <v-flex xs4 sm4 md2>
          ◉ Pan Number
        </v-flex>
        <v-flex xs8 sm8 md10>
          :&nbsp;&nbsp;{{companies.panNumber}}
        </v-flex>
      </v-layout>

      <v-layout class="form-container" row wrap style="border:1px solid;margin-top:-30px">
        <v-flex xs12 sm12 md6>
          <v-layout row wrap>
        <v-flex xs12>
          <h4 style="text-align:center;color:grey;padding-bottom:15px">Shipping Info</h4>
        </v-flex>
        <v-flex xs6 sm6 md5>
          ◉ Shipping Address
        </v-flex>
        <v-flex xs6 sm6 md7>
          :&nbsp;&nbsp;{{companies.shippingAddress}}
        </v-flex>
        <v-flex xs6 sm6 md5>
          ◉ Shipping City
        </v-flex>
        <v-flex xs6 sm6 md7>
          :&nbsp;&nbsp;{{companies.shippingCity}}
        </v-flex>
        <v-flex xs6 sm6 md5>
          ◉ Shipping Country
        </v-flex>
        <v-flex xs6 sm6 md7>
          :&nbsp;&nbsp;{{companies.shippingCountry}}
        </v-flex>
        <v-flex xs6 sm6 md5>
          ◉ Shipping State
        </v-flex>
        <v-flex xs6 sm6 md7>
          :&nbsp;&nbsp;{{companies.shippingState}}
        </v-flex>
        <v-flex xs6 sm6 md5>
          ◉ Shipping Street
        </v-flex>
        <v-flex xs6 sm6 md7>
          :&nbsp;&nbsp;{{companies.shippingStreet}}
        </v-flex>
        <v-flex xs6 sm6 md5>
          ◉ Shipping Zipcode
        </v-flex>
        <v-flex xs6 sm6 md7>
          :&nbsp;&nbsp;{{companies.shippingZipCode}}
        </v-flex>
      </v-layout>
        </v-flex>

        <v-flex xs12 sm12 md6>
          <v-layout row wrap>
        <v-flex xs12>
          <h4 style="text-align:center;color:grey;padding-bottom:15px">Billing Info</h4>
        </v-flex>
        <v-flex xs6 sm6 md5>
          ◉ Billing Address
        </v-flex>
        <v-flex xs6 sm6 md7>
          :&nbsp;&nbsp;{{companies.billingAddress}}
        </v-flex>
        <v-flex xs6 sm6 md5>
          ◉ Billing City
        </v-flex>
        <v-flex xs6 sm6 md7>
          :&nbsp;&nbsp;{{companies.billingCity}}
        </v-flex>
        <v-flex xs6 sm6 md5>
          ◉ Billing Country
        </v-flex>
        <v-flex xs6 sm6 md7>
          :&nbsp;&nbsp;{{companies.billingCountry}}
        </v-flex>
        <v-flex xs6 sm6 md5>
          ◉ Billing State
        </v-flex>
        <v-flex xs6 sm6 md7>
          :&nbsp;&nbsp;{{companies.billingState}}
        </v-flex>
        <v-flex xs6 sm6 md5>
          ◉ Billing Street
        </v-flex>
        <v-flex xs6 sm6 md7>
          :&nbsp;&nbsp;{{companies.billingStreet}}
        </v-flex>
        <v-flex xs6 sm6 md5>
          ◉ Billing Zipcode
        </v-flex>
        <v-flex xs6 sm6 md7>
          :&nbsp;&nbsp;{{companies.billingZipCode}}
        </v-flex>
      </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      companies: {},
    };
  },

  methods: {
    getData() {
      this.axios
        .get(config.API + "Companies", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.companies = res.data[0];
          this.$Progress.finish();
        })
        .catch(err => {
          this.$toaster.error(err.message);
          this.$Progress.fail();
        });
    },

    onDelete(item) {
      // alert(item.id);
      if (confirm("You want to delete this company !!")) {
        this.axios
          .delete(config.API + `Companies/${item.id}`, {
            Authorization: "bearer " + sessionStorage.getItem("token")
          })
          .then(() => {
            this.$toaster.success("Company updated successfully");
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      }
    },

    onEdit(item) {
      this.$router.push(`editCompany/${item.id}`);
    }
  },

  mounted() {
    this.$Progress.start();
    this.getData();
  }
};
</script>
<style scoped>
.bg {
  background-image: linear-gradient(-180deg, #eeeeee, #bdbdbd) !important;
  background-size:cover !important;
}
</style>
